export default __webpack_public_path__ + "static/media/header_pc.3e007814.jpg";